import { remove } from "lodash";
import { convertDate } from "@/utils/helpers";

export default {
  resetProjectState: (state) => {
    state.project_id = null;
    state.name = "";
    state.buildings = [];
    state.equipments = [];
    state.equipment_type = null;
    state.date_calibrated = null;
    state.generatingPdf = false;
    state.state = null;
    state.users = null;
    state.newState = null;
    state.stateSubscription = null;
    state.revokeAccessSubscription = null;
    state.standard = null;
    state.missingEquipmentUsers = [];
  },
  setProjectId: (state, id) => (state.project_id = id),
  setProjectData: (state, project) => {
    const {
      project_id,
      name,
      buildings,
      equipments,
      users,
      standard_id,
      date_shared,
    } = project;
    state.project_id = project_id;
    state.name = name;
    state.standard = standard_id;
    state.buildings = buildings;
    state.equipments = equipments;
    state.state = project.state;
    state.users = users;
    state.date_shared = convertDate(date_shared);
    if (equipments?.length > 0) {
      state.equipment_type = equipments[equipments.length - 1].equipment_type;
      state.date_calibrated = equipments[equipments.length - 1].date_calibrated;
    }
  },
  setMissingEquipmentUsers: (state, missingEquipmentUsers) => {
    state.missingEquipmentUsers = missingEquipmentUsers;
  },
  setGeneratingPdf: (state, value) => (state.generatingPdf = value),
  updateProjectName: (state, name) => {
    state.name = name;
    state.editedName = "";
  },
  updateStandard: (state, standard) => {
    state.standard = standard;
  },
  setAvailableStandards: (state, standards) => {
    state.available_standards = standards;
  },
  updateProjectState: (state, projectState) => {
    state.state = projectState;
  },
  setNewState: (state, projectState) => {
    state.newState = projectState;
  },
  setStateSubscription: (state, stateSubscription) => {
    state.stateSubscription = stateSubscription;
  },
  setRevokeAccessSubscription: (state, revokeAccessSubscription) => {
    state.revokeAccessSubscription = revokeAccessSubscription;
  },
  editProjectName: (state, name) => (state.editedName = name),
  addBuilding: (state, building) => {
    state.buildings.push(building);
  },
  deleteBuilding: (state, building_id) => {
    const index = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    state.buildings.splice(index, 1);
  },
  updateBuilding: (state, building) => {
    const index = state.buildings.findIndex(
      (foundBuilding) => foundBuilding.building_id === building.building_id
    );
    state.buildings[index].name = building.name;
    state.buildings[index].address = building.address;
    state.buildings[index].comments = building.comments;
  },
  addFloor: (state, { floor, building_id }) => {
    const index = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    state.buildings[index].floors.push(floor);
  },
  updateFloor: (state, { floor, building_id }) => {
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (item) => item.floor_id === floor.floor_id
    );
    state.buildings[buildingIndex].floors[floorIndex] = { ...floor };
  },
  deleteFloor: (state, { building_id, floor_id }) => {
    remove(
      state.buildings.find((building) => building.building_id === building_id)
        .floors,
      (floor) => floor.floor_id === floor_id
    );
  },
  addRoom: (state, { addedRoom, building_id, floor_id }) => {
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (floor) => floor.floor_id === floor_id
    );
    if (state.buildings[buildingIndex].floors[floorIndex].rooms) {
      state.buildings[buildingIndex].floors[floorIndex].rooms.push(addedRoom);
    } else {
      state.buildings[buildingIndex].floors[floorIndex].rooms = [addedRoom];
    }
  },
  setMaintenance: (state, active) => {
    state.maintenance = active;
  },
  setMaintenanceSubscription: (state, flagSubscription) => {
    state.flagSubscription = flagSubscription;
  },
  updateEquipments: (state, equipments) => {
    state.equipments = equipments;
    state.equipment_type = equipments[equipments.length - 1].equipment_type;
    state.date_calibrated = equipments[equipments.length - 1].date_calibrated;
  },
  updateRoomData: (state, { updatedRoomData, building_id, floor_id }) => {
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (floor) => floor.floor_id === floor_id
    );
    const roomIndex = state.buildings[buildingIndex].floors[
      floorIndex
    ].rooms.findIndex((room) => room.room_id === updatedRoomData.room_id);
    const updatedRooms = [
      ...state.buildings[buildingIndex].floors[floorIndex].rooms,
    ];
    const updatedFloors = [...state.buildings[buildingIndex].floors];
    const updatedBuildings = [...state.buildings];

    updatedRooms[roomIndex] = {
      ...updatedRooms[roomIndex],
      ...updatedRoomData,
    };
    updatedFloors[floorIndex] = {
      ...updatedFloors[floorIndex],
      rooms: updatedRooms,
    };
    updatedBuildings[buildingIndex] = {
      ...updatedBuildings[buildingIndex],
      floors: updatedFloors,
    };
    state.buildings = updatedBuildings;
  },
  deleteRoom: (state, { building_id, floor_id, room_id }) => {
    remove(
      state.buildings
        .find((building) => building.building_id === building_id)
        .floors.find((floor) => floor.floor_id === floor_id).rooms,
      (room) => room.room_id === room_id
    );
  },
  updateEquipmentType: (state, equipment_type) => {
    state.equipment_type = equipment_type;
  },
  setMeasurementConditions: (
    state,
    {
      building_id,
      floor_id,
      room_id,
      illumination_test_id,
      measurement_conditions,
    }
  ) => {
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (floor) => floor.floor_id === floor_id
    );
    const roomIndex = state.buildings[buildingIndex].floors[
      floorIndex
    ].rooms.findIndex((room) => room.room_id === room_id);
    const testIndex = state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests.findIndex(
      (test) => test.illumination_test_id === illumination_test_id
    );
    state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests[testIndex].measurement_conditions =
      measurement_conditions;
  },
  setIlluminationResults: (
    state,
    {
      building_id,
      floor_id,
      room_id,
      illumination_test_id,
      illumination_test_results,
      measurement_point_id,
    }
  ) => {
    const result = {
      ...illumination_test_results.find(
        (result) => result.measurement_point_id === measurement_point_id
      ),
    };
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (floor) => floor.floor_id === floor_id
    );
    const roomIndex = state.buildings[buildingIndex].floors[
      floorIndex
    ].rooms.findIndex((room) => room.room_id === room_id);
    const testIndex = state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests.findIndex(
      (test) => test.illumination_test_id === illumination_test_id
    );
    const resultIndex = state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests[testIndex].illumination_test_results.findIndex(
      (result) => result.measurement_point_id === measurement_point_id
    );

    if (resultIndex === -1) {
      state.buildings[buildingIndex].floors[floorIndex].rooms[
        roomIndex
      ].illumination_tests[testIndex].illumination_test_results.push(result);
    } else {
      state.buildings[buildingIndex].floors[floorIndex].rooms[
        roomIndex
      ].illumination_tests[testIndex].illumination_test_results[resultIndex] =
        result;
    }
  },
  updateIlluminationResults: (
    state,
    {
      building_id,
      floor_id,
      room_id,
      illumination_test_id,
      illumination_test_result_id,
      updatedResult,
    }
  ) => {
    const buildingIndex = state.buildings.findIndex(
      (building) => building.building_id === building_id
    );
    const floorIndex = state.buildings[buildingIndex].floors.findIndex(
      (floor) => floor.floor_id === floor_id
    );
    const roomIndex = state.buildings[buildingIndex].floors[
      floorIndex
    ].rooms.findIndex((room) => room.room_id === room_id);
    const testIndex = state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests.findIndex(
      (test) => test.illumination_test_id === illumination_test_id
    );
    const resultIndex = state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests[testIndex].illumination_test_results.findIndex(
      (result) =>
        result.illumination_test_result_id === illumination_test_result_id
    );
    state.buildings[buildingIndex].floors[floorIndex].rooms[
      roomIndex
    ].illumination_tests[testIndex].illumination_test_results[resultIndex] =
      updatedResult;
  },
  deleteIlluminationTestResult: (
    state,
    {
      building_id,
      floor_id,
      room_id,
      illumination_test_id,
      illumination_test_result_id,
    }
  ) => {
    remove(
      state.buildings
        .find((building) => building.building_id === building_id)
        .floors.find((floor) => floor.floor_id === floor_id)
        .rooms.find((room) => room.room_id === room_id)
        .illumination_tests.find(
          (test) => (test.illumination_test_id = illumination_test_id)
        ).illumination_test_results,
      (result) =>
        result.illumination_test_result_id === illumination_test_result_id
    );
  },
  updateActualNumberOfZones: (
    state,
    { building_id, floor_id, room_id, functional_test_id, savedNumberOfZones }
  ) => {
    state.buildings
      .find((building) => building.building_id === building_id)
      .floors.find((floor) => floor.floor_id === floor_id)
      .rooms.find((room) => room.room_id === room_id)
      .functional_tests.find(
        (test) => test.functional_test_id === functional_test_id
      ).actual_number_of_zones = savedNumberOfZones;
  },
  updateFunctionalTestResults: (
    state,
    { building_id, floor_id, room_id, functional_test_id, savedResults }
  ) => {
    state.buildings
      .find((building) => building.building_id === building_id)
      .floors.find((floor) => floor.floor_id === floor_id)
      .rooms.find((room) => room.room_id === room_id)
      .functional_tests.find(
        (test) => test.functional_test_id === functional_test_id
      ).functional_test_results = savedResults.map((result) => ({ ...result }));
  },
  updateLuxMeterModel: (state, model) => {
    state.luxMeterModel = model;
  },
  updateDateCalibrated: (state, date) => {
    state.date_calibrated = date;
  },
};
